import _FlashMessage from "./FlashMessage";
import _FlashMessageContainer from "./FlashMessageContainer";
import FlashMessageContext from "./FlashMessageContext";

export const FlashMessage = _FlashMessage;
export const FlashMessageContainer = _FlashMessageContainer;
export const FlashMessageConsumer = FlashMessageContext.Consumer;
export { default as FlashMessageContext } from "./FlashMessageContext";
